import { Component, OnInit } from '@angular/core';
import { NewcostingService } from './newcosting.service';

@Component({
  selector: 'app-newcosting',
  templateUrl: './newcosting.component.html',
  styleUrls: ['./newcosting.component.scss']
})
export class NewcostingComponent implements OnInit {
  costingData: any;
  loading: boolean = true;
  email: any;

  constructor(private NewcostingService: NewcostingService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getCostingData()
  }

  getCostingData() {
    this.NewcostingService.getCostingLogData(this.email).subscribe((response) => {
      this.costingData = response["data"];
      console.log("resss", this.costingData);
      this.loading = false;

    });
  }

}
